import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import PassThruACHPage, { getDefaultData } from "components/pages/PassThruACHPage";
import Classes, { Account, CompanyAccount, PassThruHistory } from "model";

export default function CaptureACHPassThruFileUploaded(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const defaultFileData = PassThruHistory.init({
    id: PassThruHistory.nextID(),
    createdBy: "George Washington",
    createdDate: "0",
    updatedDate: "",
    status: "pending approval",
    isChecked: false,
    offsetAccount: Account.initByID(6),
    companyAccount: CompanyAccount.initByID(0),
    participants: "0",
    creditAmount: "0",
    debitAmount: "100",
    secCode: "CCD",
    batchNumber: "0000260",
    rawFileName: "9202011252P_SAMPLEPASSTHRU",
    fileName: "P_samplePassThru.txt",
    fileURL: ""
  })

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["pendingACHPassThruWidgetData", "pending"], [defaultFileData])
    .update(["pendingACHPassThruWidgetData", "addedFile"], defaultFileData)
    .update(["pendingACHPassThruWidgetData", "showFileUploadedTextArea"], true)
    .update(["pendingACHPassThruWidgetData", "showFileUploadedBanner"], true)
    .submit();

  return (
    <PassThruACHPage data={data} />
  )
}
